import { RouterProvider, createBrowserRouter } from "react-router-dom";
import React, { lazy } from "react";
import ThemedSuspense from "./utils/ThemedSuspense";

// Styling Files
import "./App.css";
import "./styles/Dashboard.css";
import "./styles/Sidebar.css";
import "./styles/Receivable.css";
import "./styles/Responsive.css";

const Page404 = lazy(() => import("./pages/404/404"));
const HomePage = lazy(() => import("./pages/home/HomePage"));
const Layout = lazy(() => import("./container/Layout"));
const StockPage = lazy(() => import("./pages/stock/StockPage"));
const ReceivablePage = lazy(() => import("./pages/receivable/ReceivablePage"));
const SaleServicesPage = lazy(() =>
  import("./pages/sale_and_services/SaleServicesPage")
);
const PurchasePage = lazy(() => import("./pages/purchase/PurchasePage"));
const PayablesPage = lazy(() => import("./pages/payables/PayablesPage"));
const ExpensesPage = lazy(() => import("./pages/expenses/ExpensesPage"));
const BanksPage = lazy(() => import("./pages/banks/BanksPage"));
const CashFlowForecastPage = lazy(() =>
  import("./pages/cash_flow_forecast/CashFlowForecastPage")
);
const BudgetAndForecastPage = lazy(() =>
  import("./pages/budget_and_forecast/BudgetAndForecastPage")
);
const IndentingOrdersPage = lazy(() =>
  import("./pages/indenting_orders/IndentingOrdersPage")
);
const LCPositionPage = lazy(() => import("./pages/LC_position/LCPositionPage"));

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <Page404 />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "stock",
          element: <StockPage />,
        },
        {
          path: "receivable",
          element: <ReceivablePage />,
        },
        {
          path: "sales_services",
          element: <SaleServicesPage />,
        },
        {
          path: "purchase",
          element: <PurchasePage />,
        },
        {
          path: "payables",
          element: <PayablesPage />,
        },
        {
          path: "expenses",
          element: <ExpensesPage />,
        },
        {
          path: "banks",
          element: <BanksPage />,
        },
        {
          path: "cash_flow_forecast",
          element: <CashFlowForecastPage />,
        },
        {
          path: "budget_and_forecast",
          element: <BudgetAndForecastPage />,
        },
        {
          path: "indenting_orders",
          element: <IndentingOrdersPage />,
        },
        {
          path: "L_C_positions",
          element: <LCPositionPage />,
        },
      ],
    },
  ]);
  return (
    <React.Suspense fallback={<ThemedSuspense />}>
      <RouterProvider router={router} />
    </React.Suspense>
  );
}

export default App;
